module.exports = __webpack_public_path__ + "img/cybersecurity-img-3.ffb1c703.jpg";